const GET_PACKAGES_DATA = 'GET_PACKAGES_DATA';
const SET_PACKAGES_DATA  = 'SET_PACKAGES_DATA';

const getPackagesData = data => {
    return {
        type: GET_PACKAGES_DATA,
        data
    };
}

const setPackagesData = data => {
    return {
        type: SET_PACKAGES_DATA,
        data
    };
}

export default {
    types: {
        GET_PACKAGES_DATA,
        SET_PACKAGES_DATA,
    },    
    actions: {
        getPackagesData,
        setPackagesData,
    }
}